import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import useFetchQuestions, {
    useDeleteMessage,
    useFetchActiveQuestions, useFetchQuestionResults,
    useTriggerQuestion
  } from "../../../../hooks/useFetchQuestions";
import activeModalState from "../../../../state/ui/activeModalState";
import { BoothPageHeader, BoothCard, BoothCardContent, BoothCardFooter, BoothCardHeader, BoothTable, BoothTableBody, BoothTableCell, BoothTableRow, BoothTableHead } from "../../../../components/BoothComponent";
import { useRecoilState } from "recoil";

const ShowQuestionResults = ({ item }) => {
    const { t } = useTranslation('booth');
    const { data, loading } = useFetchQuestionResults(item?.id);

    return (
        <BoothCardContent edge={true}>
            <BoothTable>
                <BoothTableHead>
                    <BoothTableRow>
                        <BoothTableCell>
                            {t('choice')}
                        </BoothTableCell>
                        <BoothTableCell>
                            {t('vote')}
                        </BoothTableCell>
                    </BoothTableRow>
                </BoothTableHead>
                <BoothTableBody>
                    {Object.keys(item.choices).map(k => (
                        <BoothTableRow>
                            <BoothTableCell>
                                {item.choices[k].label}
                            </BoothTableCell>
                            <BoothTableCell>
                                {loading ? <i className="fas fa-fw fa-spin fa-spinner"></i> : (data?.[k] || 0)}
                            </BoothTableCell>
                        </BoothTableRow>
                    ))}
                </BoothTableBody>
            </BoothTable>
        </BoothCardContent>
    );
}

const PollQuestionCard = ({ item, active, onDelete, deleteLoading, onTrigger, triggerLoading }) => {
    const [collapseDropdown, setCollapseDropdown] = useState(true);
    const { t } = useTranslation('booth');

    const activeQuestions = active.filter(i => i.active);

    return (
        <BoothCard>
            <BoothCardHeader>
                <div className="w-full flex items-center justify-between mb-3">
                    <div className="flex items-center space-x-2 mr-auto">
                        {[`${item.duration}s`, item.layout].map(i => <div key={i} className={"px-3 py-1 bg-purple-800 text-2xs font-semibold rounded-full flex items-center space-x-2 capitalize"}>{i}</div>)}
                    </div>
                    {/*{activeQuestions.length === 0 && (
                        <div className="flex items-center space-x-2">
                            <button className="btn-light-xs">
                            <i className="fas fa-edit"></i>
                            Edit
                            </button>
                            <button className="btn-light-xs">
                            <i className="fas fa-eye"></i>
                            Preview
                            </button>
                        </div>
                    )}*/}
                </div>
                <div className="w-full flex items-center justify-between space-x-3 text-sm font-semibold leading-tight">
                    <div className="flex items-center mr-auto">
                        <div className="h-6 w-6 rounded bg-green-500 mr-2 inline-flex items-center justify-center">
                            <i className="fas fa-list text-white text-xs fa-fw"></i>
                        </div>
                        <span>{item.label}</span>
                    </div>
                    <button className={`${collapseDropdown && "transform rotate-180"}`} onClick={() => setCollapseDropdown(!collapseDropdown)}>
                        <i className="fas fa-chevron-down fa-fw"></i>
                    </button>
                </div>
            </BoothCardHeader>
            {collapseDropdown && (
                <ShowQuestionResults item={item} />
            )}
            <BoothCardFooter>
                {activeQuestions.map(i => (
                    <button key={i.id} disabled={deleteLoading} onClick={() => onDelete(i)} className="overflow-hidden -backdrop-hue-rotate-15 px-4 py-3 block rounded-lg bg-red-500 hover:bg-red-600 w-full duration-100 ease-in rounded-lg w-full relative">
                        <span>{t('hide-poll')}</span>
                    </button>
                ))}
                {activeQuestions.length === 0 && (
                    <button className="btn-primary w-full" onClick={onTrigger} disabled={triggerLoading}>
                        {t('trigger')}
                    </button>
                )}
            </BoothCardFooter>
        </BoothCard>
    )
}


const Polls = () => {

    const {t} = useTranslation('booth');
    const [collapseDropdown, setCollapseDropdown] = useState(false)
    const [triggerPoll, setTriggerPoll] = useState(false)
    const [activeModal, setShowModal] = useRecoilState(activeModalState);

    const {data: questions} = useFetchQuestions();
    const {data: activeQuestions} = useFetchActiveQuestions();
    const {loading: deleteLoading, mutate: deleteMessage} = useDeleteMessage();
    const {loading: triggerLoading, mutate: triggerQuestion} = useTriggerQuestion();

    return (
        <>
            <BoothPageHeader title={t('polls')}>
                <button onClick={() => setShowModal(prev => prev === 'poll' ? (isMobileView ? 'poll' : '') : 'poll')} className="btn-light-xs">
                    <i className="fas fa-plus fa-fw"></i>{t('create-new-poll')}
                </button>
            </BoothPageHeader>
            <div className="overflow-y-scroll hide-scrollbar">
                {questions && questions.map(item => (
                    <PollQuestionCard
                        key={item.id}
                        item={item}
                        active={activeQuestions ? activeQuestions.filter(i => i.question.id === item.id) : []}
                        onDelete={(item) => {
                            if (deleteLoading) {
                                return;
                            }
                            deleteMessage(item.id);
                        }}
                        deleteLoading={deleteLoading}
                        onTrigger={() => {
                            if (triggerLoading) {
                                return;
                            }
                            triggerQuestion(item);
                        }}
                        triggerLoading={triggerLoading}
                    />
                ))}
            </div>
        </>
    )
}
export default Polls